import { render, staticRenderFns } from "./viewMember.vue?vue&type=template&id=0b1bf272&"
import script from "./viewMember.vue?vue&type=script&lang=js&"
export * from "./viewMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports